const DEFAULT_FRACTION_DIGITS = 3

function trimFixed(value: string): string {
  const trimmed = value.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')
  return trimmed || '0'
}

function normalizeDecimalText(value: string): string {
  return value
    .trim()
    .replace(',', '.')
    .replace(/[^\d.-]/g, '')
}

export function parsePercentage(value: string | number | null | undefined): number {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0
  }

  if (value === null || value === undefined) {
    return 0
  }

  const parsed = Number(normalizeDecimalText(value))
  return Number.isFinite(parsed) ? parsed : 0
}

export function sanitizePercentageInput(
  value: string,
  fractionDigits = DEFAULT_FRACTION_DIGITS,
): string {
  const normalized = value.replace('.', ',').replace(/[^\d,]/g, '')
  const [integerRaw = '', ...fractionParts] = normalized.split(',')
  const integer = integerRaw.replace(/^0+(?=\d)/, '')
  const fraction = fractionParts.join('').slice(0, fractionDigits)
  const hasDecimalSeparator = normalized.includes(',')

  if (!integer && !hasDecimalSeparator) {
    return ''
  }

  const safeInteger = integer || '0'
  return hasDecimalSeparator ? `${safeInteger},${fraction}` : safeInteger
}

export function percentageInputToDecimalString(
  value: string,
  fractionDigits = DEFAULT_FRACTION_DIGITS,
): string {
  const sanitized = sanitizePercentageInput(value, fractionDigits)
  if (!sanitized) {
    return '0'
  }

  const normalized = sanitized.replace(',', '.')
  return normalized.endsWith('.') ? normalized.slice(0, -1) : normalized
}

export function formatPercentageInput(
  value: string | number | null | undefined,
  fractionDigits = DEFAULT_FRACTION_DIGITS,
): string {
  const parsed = parsePercentage(value)
  return trimFixed(parsed.toFixed(fractionDigits)).replace('.', ',')
}

export function percentageInputToFixed(
  value: string | number | null | undefined,
  min: number,
  max: number,
  fractionDigits = DEFAULT_FRACTION_DIGITS,
): string {
  const parsed = parsePercentage(value)
  const clamped = Math.min(max, Math.max(min, parsed))
  return clamped.toFixed(fractionDigits)
}

export function formatPercentageLabel(
  value: string | number | null | undefined,
  fractionDigits = DEFAULT_FRACTION_DIGITS,
): string {
  return `${formatPercentageInput(value, fractionDigits)}%`
}
